export default "__VITE_ASSET__6a467721__"